import { code } from "@spscommerce/utils";

export const SpsRadioButtonExamples = {
    labels: {
        label: "Labels",
        description: "info about radio buttons with labels",
        examples: {
            label: {
                template: code`
                    <form [formGroup]="form" id="basicRadioExample">
                        <sps-radio-button value="blue" label="Blue" formControlName="labels">
                        </sps-radio-button>
                        <sps-radio-button value="green" label="Green" formControlName="labels">
                        </sps-radio-button>
                    </form>
                `,
                class: code`
                    class DemoComponent implements OnInit {
                        constructor(private _formBuilder: FormBuilder) {}
                        form: FormGroup;
                        ngOnInit() {
                            this.form = this._formBuilder.group({
                                labels: ["blue"]
                            });
                        }
                    }
                `
            }
        }
    },
    disabled: {
        label: "Disabled",
        description: "info about disabled radio buttons",
        examples: {
            disabled: {
                template: code`
                    <form [formGroup]="form" id="disabledRadioExample">
                        <sps-radio-button value="blue" label="Blue" formControlName="disabled">
                        </sps-radio-button>
                        <sps-radio-button value="green" label="Green" formControlName="disabled">
                        </sps-radio-button>
                    </form>
                `,
                class: code`
                    class DemoComponent implements OnInit {
                        constructor(private _formBuilder: FormBuilder) {}
                        form: FormGroup;
                        ngOnInit() {
                            this.form = this._formBuilder.group({
                                disabled: [{ value: "blue", disabled: true }]
                            });
                        }
                    }
                `
            }
        }
    },
    noLabels: {
        label: "No Labels",
        description: "info about radio buttons without labels",
        examples: {
            noLabels: {
                template: code`
                    <form [formGroup]="form">
                        <sps-radio-button value="blue" formControlName="noLabels">
                        </sps-radio-button>
                        <sps-radio-button value="green" formControlName="noLabels">
                        </sps-radio-button>
                    </form>
                `,
                class: code`
                    class DemoComponent implements OnInit {
                        constructor(private _formBuilder: FormBuilder) {}
                        form: FormGroup;
                        ngOnInit() {
                            this.form = this._formBuilder.group({
                                noLabels: ["green"]
                            });
                        }
                    }
                `
            }
        }
    }
};
